import { createAsyncThunkFromFetch } from 'src/store/utils';
import {
  GetOfflineHeadsetsQueryParams,
  GetOfflineHeadsetsResponse,
} from './offlineHeadsets.types';
import { getOfflineHeadsetsAPI } from './offlineHeadsets.api';

export const getOfflineHeadsetsAction = createAsyncThunkFromFetch<
  GetOfflineHeadsetsResponse,
  {
    params: GetOfflineHeadsetsQueryParams;
  }
>(`offlineHeadsets`, getOfflineHeadsetsAPI);
